function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.283 49.713 v 9.625 c 0 3.335 2.703 6.038 6.038 6.038 h 52.482 c 3.335 0 6.038 -2.703 6.038 -6.038 V 24.504 c 0 -3.335 -2.703 -6.038 -6.038 -6.038 H 25.321 c -3.335 0 -6.038 2.703 -6.038 6.038 v 9.51 C 19.283 34.014 19.283 49.713 19.283 49.713 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(218,224,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.085 43.342 H 7.142 c -0.785 0 -1.421 -0.636 -1.421 -1.421 S 6.357 40.5 7.142 40.5 h 16.943 c 0.785 0 1.421 0.636 1.421 1.421 C 25.506 42.706 24.87 43.342 24.085 43.342 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(218,224,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.839 33.41 H 1.421 C 0.636 33.41 0 32.774 0 31.989 s 0.636 -1.421 1.421 -1.421 h 10.418 c 0.785 0 1.421 0.636 1.421 1.421 C 13.26 32.774 12.624 33.41 11.839 33.41 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(218,224,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.839 53.275 H 4.162 c -0.785 0 -1.421 -0.637 -1.421 -1.421 c 0 -0.785 0.636 -1.421 1.421 -1.421 h 7.677 c 0.785 0 1.421 0.637 1.421 1.421 S 12.624 53.275 11.839 53.275 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(218,224,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.541 71.534 H 30.058 c -4.113 0 -7.459 -3.346 -7.459 -7.459 V 54.45 c 0 -0.785 0.636 -1.421 1.421 -1.421 c 0.785 0 1.421 0.637 1.421 1.421 v 9.625 c 0 2.545 2.071 4.617 4.617 4.617 h 52.483 c 2.545 0 4.617 -2.071 4.617 -4.617 V 29.241 c 0 -2.546 -2.071 -4.617 -4.617 -4.617 H 30.058 c -2.546 0 -4.617 2.071 -4.617 4.617 v 9.51 c 0 0.785 -0.636 1.421 -1.421 1.421 c -0.785 0 -1.421 -0.636 -1.421 -1.421 v -9.51 c 0 -4.113 3.346 -7.459 7.459 -7.459 h 52.483 c 4.112 0 7.459 3.346 7.459 7.459 v 34.834 C 90 68.187 86.654 71.534 82.541 71.534 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.299 54.238 c -0.344 0 -0.689 -0.125 -0.96 -0.374 l -23.7 -21.743 c -0.578 -0.531 -0.617 -1.43 -0.087 -2.008 c 0.531 -0.578 1.429 -0.616 2.008 -0.087 l 22.739 20.862 L 79.04 30.027 c 0.579 -0.53 1.477 -0.491 2.008 0.087 c 0.53 0.579 0.491 1.477 -0.087 2.008 L 57.259 53.864 C 56.988 54.113 56.643 54.238 56.299 54.238 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.6 63.663 c -0.384 0 -0.767 -0.155 -1.048 -0.461 c -0.531 -0.578 -0.492 -1.477 0.087 -2.008 L 48.626 45.61 c 0.578 -0.529 1.477 -0.491 2.008 0.087 c 0.53 0.578 0.491 1.477 -0.087 2.008 L 33.56 63.29 C 33.287 63.539 32.943 63.663 32.6 63.663 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80 63.663 c -0.343 0 -0.687 -0.124 -0.96 -0.374 L 62.053 47.705 c -0.578 -0.531 -0.617 -1.43 -0.087 -2.008 c 0.531 -0.578 1.429 -0.617 2.008 -0.087 L 80.96 61.195 c 0.578 0.531 0.617 1.429 0.087 2.008 C 80.767 63.509 80.384 63.663 80 63.663 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.822 48.079 H 11.879 c -0.785 0 -1.421 -0.636 -1.421 -1.421 s 0.636 -1.421 1.421 -1.421 h 16.943 c 0.785 0 1.421 0.636 1.421 1.421 C 30.243 47.443 29.607 48.079 28.822 48.079 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.576 38.147 H 6.158 c -0.785 0 -1.421 -0.636 -1.421 -1.421 s 0.636 -1.421 1.421 -1.421 h 10.418 c 0.785 0 1.421 0.636 1.421 1.421 C 17.997 37.511 17.361 38.147 16.576 38.147 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.576 58.012 H 8.899 c -0.785 0 -1.421 -0.637 -1.421 -1.421 c 0 -0.784 0.636 -1.421 1.421 -1.421 h 7.677 c 0.785 0 1.421 0.637 1.421 1.421 C 17.997 57.375 17.361 58.012 16.576 58.012 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(43,70,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.13956bb6.svg";
export { ForwardRef as ReactComponent };